export var ImpressionDataEventType;
(function (ImpressionDataEventType) {
    ImpressionDataEventType["IS_ENABLED"] = "isEnabled";
    ImpressionDataEventType["GET_VARIANT"] = "getVariant";
})(ImpressionDataEventType || (ImpressionDataEventType = {}));
//# sourceMappingURL=impression-data-event-type.enum.js.map